import {
  L0CardHeader,
  L1CardHeader,
  L2CardHeader,
  L3CardHeader,
  L4CardHeader,
  obstructedCardHeader,
  W2NonOperationalCardHeader,
  inactiveCardHeader
} from "../../assets/jss/wisene-material-dashboard-pro-react.jsx";

const wiseneCardIconStyle = {
  WiseneCardIcon: {
    "&$L0CardHeader,&$L1CardHeader,&$L2CardHeader,&$L3CardHeader,&$L4CardHeader,&$obstructedCardHeader,&$W2NonOperationalCardHeader,&$inactiveCardHeader": {
      borderRadius: "3px",
      backgroundColor: "#999",
      padding: "15px",
      marginTop: "-20px",
      marginRight: "15px",
      float: "left"
    }
  },
  L0CardHeader,
  L1CardHeader,
  L2CardHeader,
  L3CardHeader,
  L4CardHeader,
  obstructedCardHeader,
  W2NonOperationalCardHeader,
  inactiveCardHeader
};

export default wiseneCardIconStyle;
